var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProviderContacts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#784ace;}.cls-2{fill:#00a0df;}.cls-3{fill:#00d89a;}.cls-4{fill:#febe10;}.cls-5{fill:#a67c52;}.cls-6{fill:#fffbc5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "provider_contacts"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 519.96,
    y: 323.99,
    width: 65.49,
    height: 108.79,
    rx: 32.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 519.96,
    y: 203.66,
    width: 65.49,
    height: 108.79,
    rx: 32.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 519.96,
    y: 83.33,
    width: 65.49,
    height: 108.79,
    rx: 32.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 55,
    y: 0.09,
    width: 497.7,
    height: 600,
    rx: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.81.09H147a0,0,0,0,1,0,0v600a0,0,0,0,1,0,0H84.05A29.05,29.05,0,0,1,55,571V29.91A29.81,29.81,0,0,1,84.81.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M393.93,312.3A69.83,69.83,0,0,1,429.8,322a72.34,72.34,0,0,1,35.87,62.52v22.64a25.06,25.06,0,0,1-7.49,18.33,24.72,24.72,0,0,1-18.2,7.55H251.52a24.72,24.72,0,0,1-18.2-7.55,25,25,0,0,1-7.49-18.33V384.53A72.34,72.34,0,0,1,261.7,322a69.83,69.83,0,0,1,35.87-9.71h9.1a92.8,92.8,0,0,0,78.16,0Zm-48.18-17.24a67.95,67.95,0,0,1-59.43-34.23,71,71,0,0,1,0-69.54,68.54,68.54,0,0,1,118.86,0,71,71,0,0,1,0,69.54,67.95,67.95,0,0,1-59.43,34.23Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderContacts);
export default __webpack_public_path__ + "static/media/provider_contacts.fa557295e0dcb6dfdc46ab4725d65222.svg";
export { ForwardRef as ReactComponent };